const TODO_KEY = 'svelte_todo_list';
const getItem = (key) => key ? JSON.parse(localStorage.getItem(key)) : null;
const setItem = (key, value) => key ? localStorage.setItem(key, JSON.stringify(value)) : null;
const removeItem = (key) => (key ? localStorage.removeItem(key) : null);
const clearAll = () => localStorage.clear();
export { getItem, setItem, removeItem, clearAll, TODO_KEY };
